export const BILLING_DETAILS_TITLE: string = 'Current billing cycle';
export const BILLING_BUTTON_TEXT: string = 'Create next billing run';
